import React from 'react'
import { components, MultiValueRemoveProps } from 'react-select'

import Icon from '../../Icon'

const MultiValueRemove = (props: MultiValueRemoveProps) => {
  return (
    <components.MultiValueRemove {...props}>
      <Icon name='Close-solid' size='14px' color='black50' />
    </components.MultiValueRemove>
  )
}

export default MultiValueRemove
